module.exports = __webpack_public_path__ + "static/media/Uvaly.1eeac1b0.md";